// eslint-disable-next-line import/no-cycle
import accountApi from '../api/accountApi';

import * as types from './types';

const actions = {
  [types.FETCH_ACCOUNT]: (context) => accountApi.getAccount().then((response) => {
    context.commit(types.SET_ACCOUNT, response);
    return response;
  }),
  [types.UPDATE_ACCOUNT]: (context, payload) => {
    const existingAccount = {
      id: context.state.id,
      ...payload,
    };
    const checkCondition = (resolve, reject) => {
      accountApi.updateAccount(existingAccount)
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    };
    return new Promise(checkCondition);
  },
  [types.UPDATE_AVATAR_COLOUR]: (context, avatarColour) => {
    const payload = {
      id: context.state.id,
      avatarColour,
    };
    return accountApi.updateAvatarColour(payload)
      .then((response) => {
        context.commit(types.SET_AVATAR_COLOUR, response);
      });
  },
  [types.FETCH_INVOICING_DETAILS]: (context, payload) => {
    if (payload.isManagedCampaign) {
      const advertiserDetails = accountApi
        .getAdvertiserInvoicingDetails(context.rootState.campaigns.selectedAdvertiser)
        .then((response) => response);
      const agencyDetails = accountApi
        .getAgencyInvoicingDetails(context.rootState.campaigns.campaign.agencyId)
        .then((response) => response);
      return Promise.all([
        advertiserDetails,
        agencyDetails,
      ])
        .then(async (res) => ({
          advertiser: res[0],
          agency: res[1],
        }));
    }
    const campaignDetails = accountApi
      .getCampaignInvoicingDetails(context.rootState.campaigns.campaign.id)
      .then((response) => response);
    const accountDetails = accountApi
      .getAccountsInvoicingDetails(context.rootState.account.id)
      .then((response) => response);
    return Promise.all([
      campaignDetails,
      accountDetails,
    ])
      .then(async (res) => ({
        campaign: res[0],
        account: res[1],
      }));
  },
  [types.UPDATE_INVOICING_DETAILS]: (context, { type, selectedDetailsId, payload }) => {
    const checkCondition = (resolve, reject) => {
      if (selectedDetailsId) {
        accountApi.putInvoicingDetails(payload, context.rootState.campaigns.campaign.id, selectedDetailsId)
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      } else {
        // eslint-disable-next-line no-nested-ternary
        const id = type === 'advertiser'
          ? context.rootState.campaigns.selectedAdvertiser.id
          : type === 'agency' ? context.rootState.campaigns.campaign.agencyId : context.rootState.account.id;

        payload.campaignId = context.rootState.campaigns.campaign.id;
        const newInvoicingDetails = {
          id,
          body: payload,
        };
        // eslint-disable-next-line no-nested-ternary
        const promise = type === 'advertiser' ? accountApi.postAdvertiserInvoicingDetails
          : type === 'agency' ? accountApi.postAgencyInvoicingDetails : accountApi.postAccountsInvoicingDetails;
        promise(newInvoicingDetails)
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      }
    };
    return new Promise(checkCondition);
  },
  [types.FETCH_ACCOUNT_BY_ID]: (_, payload) => accountApi
    .getAccountById(payload)
    .then((response) => response),
  [types.FETCH_ALL_USERS_IN_ROLE]: (_, role) => accountApi
    .getUsersByRole(role)
    .then((response) => response),
  [types.GET_USER_EMAIL_EXIST]: (context, payload) => accountApi.getUserEmailExists(payload.email.toLowerCase())
    .then((status) => status === 200),
  [types.FETCH_SHARED_ADVERTISERS]: () => accountApi.fetchSharedAdvertisers()
    .then((response) => response),
};

export default actions;
